import type { ScopeType } from '@zrsystem/contracts';
import type { ContextSwitcherSection } from '@zrsystem/ui';

export type NavigationLevel = 'place' | 'tenant' | 'network' | 'platform';

export const SCOPE_TO_NAVIGATION_LEVEL: Record<ScopeType, NavigationLevel> = {
  PLACE: 'place',
  TENANT: 'tenant',
  ORGANIZATION_GROUP: 'network',
  SYSTEM: 'platform',
};

export const NAVIGATION_LEVEL_TO_SCOPE: Record<NavigationLevel, ScopeType> = {
  place: 'PLACE',
  tenant: 'TENANT',
  network: 'ORGANIZATION_GROUP',
  platform: 'SYSTEM',
};

export interface PlaceSummary {
  id: string;
  name: string;
  subtitle?: string;
}

export interface TenantSummary {
  id: string;
  name: string;
  subtitle?: string;
}

export interface NetworkSummary {
  id: string;
  name: string;
  subtitle?: string;
}

export interface NavigationContextValue {
  level: NavigationLevel;
  activeEntityId: string | null;
  allowedPlaces: PlaceSummary[];
  allowedTenants: TenantSummary[];
  allowedNetworks: NetworkSummary[];
  hasPlatformAccess: boolean;
  contextLabel: string;
  isStaticSwitcher: boolean;
  isReady: boolean;
  switcherSections: ContextSwitcherSection[];
  setLevel: (level: NavigationLevel, entityId?: string) => Promise<void>;
}

export type { ActiveContext, UserAccessSummary } from '@zrsystem/contracts';
